import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

export const SubscriptionContext = createContext(null);

export function SubscriptionProvider({ children, subscriptionData }) {
  return (
    <SubscriptionContext.Provider value={subscriptionData}>
      {children}
    </SubscriptionContext.Provider>
  );
}

SubscriptionProvider.propTypes = {
  children: PropTypes.node.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

export function useSubscription() {
  const context = useContext(SubscriptionContext);
  if (context === null) {
    throw new Error(
      'useSubscription must be used within a SubscriptionProvider',
    );
  }
  return context;
}
